import styles from './md-page.module.scss'
import { cn } from '@/lib/utils'


type Props = {
  children: React.ReactNode
}

const MdxPage = ({ children }: Props) => {
  return (
    <div className={cn(styles.pages, 'mdx')}>
      {children}
    </div>
  )
}

export default MdxPage
